var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex w-full gap-x-2.5 pt-4"},[_c('div',{staticClass:"h-9 w-9 animate-pulse rounded-full bg-ink-300"}),_vm._v(" "),_c('div',{staticClass:"flex-grow pb-4",class:{ 'border-b border-ink-300': !_vm.hideBorder }},[_c('div',{staticClass:"h-10 animate-pulse rounded-md bg-ink-300"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }